import React, { useState } from 'react';
import { Box, Button, Modal, Typography, Table, TableBody, TableCell, TableHead, TableRow, Paper, TableContainer } from '@mui/material';
import { useNavigate } from 'react-router-dom'; // Pour rediriger vers la page d'édition
import { getUserProvider } from '../../../../actions/auth.js'; // Pour obtenir le provider de l'utilisateur
import useStyles from '../../../../styles/global-mui.js';
import DsasButton from '../../../components/DsasButton/DsasButton.js';
import { faPenToSquare } from '@fortawesome/free-solid-svg-icons';

const PlayerCheckModal = ({ open, onClose, results, onSelectOtherPlayer, onConfirmNone, actualProvider = getUserProvider() }) => {
  const navigate = useNavigate();

  const handleSelectMyPlayer = (playerId) => {
    navigate(`/sports/players/create/${playerId}`);
  };

  const handleSelectOtherPlayer = (player) => {
    onSelectOtherPlayer(player);
    onClose();
  };

  const classes = useStyles();

  return (
    <Modal open={open} onClose={onClose}>
      <Paper
        sx={{
          width: '90%', // 90% de la largeur de l'écran
          maxWidth: '600px', // Limite de la largeur maximale
          margin: 'auto',
          marginTop: { xs: '10%', md: '5%' }, // Gérer la marge en fonction de la taille de l'écran
          maxHeight: '90vh', // Limite de la hauteur
          overflowY: 'auto', // Activer le défilement si le contenu dépasse la hauteur
          boxSizing: 'border-box',
        }}
      >
        <Box className='medium-padding'>
          {/* <Typography variant="h6" gutterBottom>Vérification des joueurs existants</Typography> */}
          <Box className='centered-wrapper'>
            <h3 className='page-title'>Vérification des joueurs existants</h3>
          </Box>
          
          <Box className='medium-padding'>
          {/* Vos joueurs */}
          <h5 className='page-title'>Vos joueurs</h5>

          {!results
                  .filter((player) => player.provider === actualProvider).length ? 
                  <Typography variant="subtitle1">Aucun de vos joueurs ne correspond à la recherche</Typography>
                  :
          (<TableContainer sx={{ maxWidth: '100%', overflowX: 'auto' }}>
          <Table className={classes.customTable} size="small" sx={{ minWidth: '100%' }}>
            <TableHead>
              <TableRow>
                <TableCell>Nom</TableCell>
                <TableCell>Prénom</TableCell>
                <TableCell>Discipline</TableCell>
                <TableCell>Équipe(s)</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {results
                .filter((player) => player.provider === actualProvider)
                .map((player) => (
                  <TableRow key={player._id}>
                    <TableCell>{player.lastname}</TableCell>
                    <TableCell>{player.firstname}</TableCell>
                    <TableCell>{player.discipline}</TableCell>
                    <TableCell>{player.teams.map((team) => team.name).join(', ')}</TableCell>
                    <TableCell>
                      <DsasButton icon={faPenToSquare} label="Editer" onClick={() => handleSelectMyPlayer(player._id)} variant = 'secondary'/>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>)
          }
          </Box>
          <Box className='medium-padding'>

          

          {/* Les autres joueurs */}
          <h5 className='page-title'>Nos suggestions de joueurs</h5>

          <TableContainer sx={{ maxWidth: '100%', overflowX: 'auto' }}>
            <Table className={classes.customTable} size="small" sx={{ minWidth: '100%' }}>
              <TableHead>
                <TableRow>
                  <TableCell>Nom</TableCell>
                  <TableCell>Prénom</TableCell>
                  <TableCell>Discipline</TableCell>
                  <TableCell>Équipe(s)</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {results
                  .filter((player) => player.provider !== actualProvider)
                  .map((player) => (
                    <TableRow key={player._id}>
                      <TableCell>{player.lastname}</TableCell>
                      <TableCell>{player.firstname}</TableCell>
                      <TableCell>{player.discipline}</TableCell>
                      <TableCell>{player.teams.map((team) => team.name).join(', ')}</TableCell>
                      <TableCell>
                        <Button size="small" variant="contained" onClick={() => handleSelectOtherPlayer(player)}>
                          Utiliser
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Aucun des joueurs ne correspond */}
          <Box sx={{ textAlign: 'center', marginTop: 3 }}>
            <Table className={classes.customTable} size="small" sx={{ minWidth: '100%' }}>
              <TableBody>
                <TableRow>
                  <TableCell className='no-border' sx={{ textAlign: 'center' }}>
                    <Box className='centered-wrapper' sx={{ textAlign: 'center' }} >
                    <DsasButton label="Aucun des joueurs ne correspond à mon joueur" onClick={onConfirmNone} variant = 'primary' focused={true}/>
                    </Box>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Box>

          </Box>
        </Box>
      </Paper>
    </Modal>
  );
};

export default PlayerCheckModal;
